import styled from 'styled-components';

interface INotificationProps {
  read: boolean;
}

export const Container = styled.div`
  position: relative;
  z-index: 1;
  button {
    min-width: 2rem;
    border-radius: 1.5rem;
    position: relative;
    .bellNotification {
      fill: ${({ theme }) => theme.colors.background_white};
      min-width: 2rem;
      min-height: 1.5rem;
    }
    .numberNotification {
      position: absolute;
      background: ${({ theme }) => theme.colors.yellow};
      border-radius: 50%;
      width: 1.3rem;
      height: 1.3rem;
      max-width: 1.3rem;
      max-height: 1.3rem;
      top: -0.2rem;
      left: 0rem;
      p {
        font-size: 0.8rem;
      }
    }
  }
`;
export const Content = styled.div`
  width: 25rem;
  background: ${({ theme }) => theme.colors.background_white};
  right: 0.5rem;
  display: flex;
  padding: 0 0 0 10px;
  flex-direction: column;
  border-radius: 10px;
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.2);
  .headerNotifications {
    width: 100%;
    display: flex;
    padding: 0.5rem 0;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray_200};
    h1 {
      font-size: 1.5rem;
      color: ${({ theme }) => theme.colors.secondary};
      font-weight: 500;
    }
  }
  .containerNotification {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding-right: 5px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.gray_200};
    max-height: 25rem;
    min-height: 20rem;
    margin-top: 1rem;
    overflow-y: auto;
    padding-bottom: 1rem;

    .noNotification {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }
`;
export const NotificationButton = styled.div`
  all: unset;
  cursor: pointer;
  display: inline-block;

  &:hover {
    opacity: 0.8;
  }

  p {
    display: flex;
    align-items: center;
    font-size: 15px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray};
  }
`;

export const Notification = styled.div<INotificationProps>`
  display: grid;
  grid-template-columns: 10% 80% 10%;
  align-items: center;
  background: ${({ theme, read }) =>
    !read ? theme.colors.background : theme.colors.background_white};
  border-radius: 8px;
  padding: 0.5rem 1rem;
  border: 1px solid ${({ theme }) => theme.colors.background};
  svg {
    fill: ${({ theme }) => theme.colors.primary};
    font-size: 2rem;
  }
  p {
    display: flex;
    align-items: center;
    font-size: 15px;
    text-align: center;
    color: ${({ theme }) => theme.colors.gray};
  }
  &:hover {
    opacity: 0.9;
    border: 1px solid ${({ theme }) => theme.colors.gray_275};
  }
`;
